export class AuthPin {
	private readonly inputSelector = 'input[id^=\'pin\']'
	private readonly submitSelector = 'button[type=\'submit\']'
	private isActivated = false

	activate(): void {
		if (this.isActivated) {
			return
		}

		document.addEventListener('input', this.onInput)
		document.addEventListener('keydown', this.onKeyDown)
		this.isActivated = true
	}

	private onInput = (event: Event): void => {
		const input = event.target as HTMLInputElement | null
		if (!input?.matches(this.inputSelector)) {
			return
		}

		input.value = input.value.replace(/\D/g, '').slice(0, 1)

		if (input.value.length !== 1) {
			return
		}

		const inputs = Array.from(document.querySelectorAll<HTMLInputElement>(this.inputSelector))
		const index = inputs.indexOf(input)

		if (index < inputs.length - 1) {
			inputs[index + 1].focus()
			inputs[index + 1].select()
			return
		}

		const button = document.querySelector<HTMLButtonElement>(this.submitSelector)
		button?.focus()
	}

	private onKeyDown = (event: KeyboardEvent): void => {
		const input = event.target as HTMLInputElement | null
		if (event.key !== 'Backspace') {
			return
		}

		if (input?.matches(this.inputSelector)) {
			if (input.value.length !== 0) {
				return
			}

			const inputs = Array.from(document.querySelectorAll<HTMLInputElement>(this.inputSelector))
			const index = inputs.indexOf(input)

			if (index > 0) {
				inputs[index - 1].focus()
				inputs[index - 1].select()
			}
			return
		}

		const submit = event.target as HTMLButtonElement | null
		if (!submit?.matches(this.submitSelector)) {
			return
		}

		event.preventDefault()

		const inputs = Array.from(document.querySelectorAll<HTMLInputElement>(this.inputSelector))
		const lastInput = inputs.at(-1)
		if (!lastInput) {
			return
		}

		lastInput.value = ''
		lastInput.focus()
		lastInput.select()
	}
}
